import { lazy } from "react";
import { DefaultLayout } from "../../layout";
import { withSuspense } from "../../routes/helpers";

const RawFileUpload = lazy(() => import("./RawFileUpload"));

const L = DefaultLayout;
const W = withSuspense;

export function getRawFileUploadRoutes() {
  return [
    { path: "/raw-file-upload/:id", layout: L, element: W(RawFileUpload) },
  ];
}
